import { PriceTaxMapper } from './PriceTaxMapper.js';

/**
 * Plain object Packlink's API response representation.
 *
 */

class PriceDetailMapper {
  static createModelFromResponse(response) {
    var _response$taxes;
    if (!response) {
      return undefined;
    }
    return {
      basePrice: typeof response.base_price === 'number' ? response.base_price : undefined,
      taxPrice: typeof response.tax_price === 'number' ? response.tax_price : undefined,
      totalPrice: typeof response.total_price === 'number' ? response.total_price : undefined,
      currency: response.currency,
      taxes: ((_response$taxes = response.taxes) === null || _response$taxes === void 0 ? void 0 : _response$taxes.map(PriceTaxMapper.createModelFromResponse)) || undefined
    };
  }
}

export { PriceDetailMapper };
//# sourceMappingURL=PriceDetailMapper.js.map
